import React from 'react';

interface Props {
  width?: number;
}

const Card = ({ width = 34 }: Props) => (
  <svg width={width} height="36" viewBox="0 0 34 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <rect x="32" width="32" height="30" rx="2" transform="rotate(90 32 0)" fill="#FCAD0D" />
      <rect x="6" y="14" width="22" height="2" rx="1" fill="#FADA99" />
      <rect x="6" y="20" width="22" height="1" rx="0.5" fill="#FADA99" />
      <rect x="6" y="23" width="22" height="1" rx="0.5" fill="#FADA99" />
      <rect x="6" y="26" width="17" height="1" rx="0.5" fill="#FADA99" />
      <circle cx="17.5" cy="7.5" r="3.5" fill="#FADA99" />
    </g>
  </svg>
);

export default Card;
